import React, { useContext } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@material-ui/core";

import { Close } from "@material-ui/icons";
import { DiscountSpan } from "../styles/VendaRapida";
import { VendaRapidaContext } from "../contexts/VendaRapidaContext";

const ModalVisualizarDesconto = ({ modalOpen, setModalOpen }) => {
  const { userMaximumDiscountPercentage } = useContext(VendaRapidaContext);
  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Dialog open={modalOpen} fullWidth maxWidth="xs">
      <DialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        children={
          <Grid container justifyContent="space-between" alignItems="center">
            {"Desconto máximo"}
            <IconButton aria-label="close" onClick={handleClose} size="small">
              <Close />
            </IconButton>
          </Grid>
        }
      />
      <DialogContent>
        <Grid container spacing={2}>
          <DiscountSpan>
            Atualmente, o desconto máximo é{" "}
            <b>{userMaximumDiscountPercentage} %</b>
          </DiscountSpan>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ModalVisualizarDesconto;
